import {
  doc,
  onSnapshot,
  FirestoreError,
  Unsubscribe,
} from "firebase/firestore";
import { db } from "../firebase";
import { EntityGet, EntityServerGet, OnSnapshotDocService } from "../types";
import { Prompt } from "./types";
import { transformMetadata, processTimestampFields } from "../utils";

export type PromptOnSnapshotDocService<T> = (
  id: string,
  callback: (doc: T) => void,
  onError?: (error: FirestoreError) => void
) => Unsubscribe;

const onSnapshotDoc: PromptOnSnapshotDocService<EntityGet<Prompt>> = (
  id,
  callback,
  onError
) => {
  const docRef = doc(db, `/prompt/${id}`);
  return onSnapshot(
    docRef,
    (docSnap) => {
      if (docSnap.exists()) {
        callback(
          processTimestampFields(
            transformMetadata(
              {
                ...docSnap.data(),
                id: docSnap.id,
              } as EntityServerGet<Prompt>,
              docSnap.metadata
            )
          ) as EntityGet<Prompt>
        );
      }
    },
    onError
  );
};

export default onSnapshotDoc;
